export const graphqlEndpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT ?? "dashboard"
export const graphqlUriLegacy = `${import.meta.env.VITE_GRAPHQL_HOST}/api/${graphqlEndpoint}/__graphql`
export const graphqlUri = graphqlUriLegacy

// Primary api/experience endpoint
export const restEndpoint = import.meta.env.VITE_CORE_REST_ENDPOINT
export const graphqlUriPrimary = `${restEndpoint}/graphql`
